import { createAction, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import i18next from 'i18next'
import { APIError, authenticatedRequest, getExceptionPayload } from '../axiosConfiguration'
import {
  TollingAccountData,
  TollingAccountRequest
} from '../type/tollingAccounts'
import * as layoutActions from './layout'
import i18n from '../../i18n'

export const getTollingAccounts = createAsyncThunk<TollingAccountData, TollingAccountRequest, { rejectValue: APIError }>(
  'tolling-accounts/getTollingAccounts',
  async (requestPayload, { dispatch, rejectWithValue }) => {
    dispatch(layoutActions.startLoading())

    try {
      const instance = await authenticatedRequest()
      const currentLocale = i18n.language

      const res = await instance.get<TollingAccountData>('/tollingaccount?language_code=' + currentLocale)

      dispatch(layoutActions.endLoading())

      return res.data
    } catch (error) {
      const err = getExceptionPayload(error, 'tollingAccountManagement:error.getTollingAccounts')

      dispatch(layoutActions.endLoading())
      dispatch(layoutActions.showToast({ summary: err.message, severity: 'error' }))

      return rejectWithValue(err)
    }
  },
)
